import { Switch, Route } from "react-router-dom"
import ImportsInterface from "./ImportsInterface"
import ImportsShow from "./ImportsShow"

export default function Imports({ types, deprecatedTypes, backUrl, showUrl }) {
  return (
    <Switch>
      <Route path={showUrl}>
        <ImportsShow backUrl={backUrl} deprecatedTypes={deprecatedTypes} />
      </Route>
      <Route>
        <ImportsInterface
          types={types}
          deprecatedTypes={deprecatedTypes}
          showUrl={showUrl}
        />
      </Route>
    </Switch>
  )
}
